import { render } from "./TitleDescriptionField.vue?vue&type=template&id=dc4295fc&scoped=true"
import script from "./TitleDescriptionField.vue?vue&type=script&lang=js"
export * from "./TitleDescriptionField.vue?vue&type=script&lang=js"

import "./TitleDescriptionField.vue?vue&type=style&index=0&id=dc4295fc&scoped=true&lang=css"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4295fc"]])

export default __exports__